module.exports = __webpack_public_path__ + "img/img72.279fbfba.png";